import script from "./CTAItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CTAItem.vue?vue&type=script&setup=true&lang=js"

import "./CTAItem.vue?vue&type=style&index=0&id=27212c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27212c3e"]])

export default __exports__